var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": _vm.isMobile ? false : true,
      "flat": ""
    }
  }, [_c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isUpdateChangesDialogActive,
      expression: "isUpdateChangesDialogActive"
    }]
  }, [_c('v-alert', {
    attrs: {
      "type": "warning",
      "outlined": "",
      "dense": "",
      "border": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center mt-n1 mb-n1"
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailSave.unsavedChanges")) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.isSaveChangesLoading,
      "elevation": 0
    },
    on: {
      "click": _vm.abortChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "loading": _vm.isSaveChangesLoading,
      "disabled": !_vm.isValid,
      "elevation": 0,
      "color": "success"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")])], 1)])], 1), _vm.valueCopy ? _c('v-card-text', {
    class: _vm.isMobile ? 'px-0' : ''
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.repairEstimate.number'),
      "hint": _vm.$t('objects.repairEstimate.numberHint'),
      "persistent-hint": _vm.value.canUpdate && _vm.canUpdate,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "readonly": !_vm.value.canUpdate || !_vm.canUpdate
    },
    model: {
      value: _vm.valueCopy.number,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "number", $$v);
      },
      expression: "valueCopy.number"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "py-4",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("components.RepairEstimateResponseCard.text")) + " ")])])], 1), _c('line-items-form', {
    attrs: {
      "isValid": _vm.isValid,
      "showQuantity": true,
      "readonly": !_vm.value.canUpdate || !_vm.canUpdate
    },
    on: {
      "update:isValid": function updateIsValid($event) {
        _vm.isValid = $event;
      },
      "update:is-valid": function updateIsValid($event) {
        _vm.isValid = $event;
      }
    },
    model: {
      value: _vm.valueCopy,
      callback: function callback($$v) {
        _vm.valueCopy = $$v;
      },
      expression: "valueCopy"
    }
  })], 1)], 1) : _vm._e(), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isUpdateChangesDialogActive,
      expression: "isUpdateChangesDialogActive"
    }]
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.isSaveChangesLoading,
      "elevation": 0
    },
    on: {
      "click": _vm.abortChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "loading": _vm.isSaveChangesLoading,
      "disabled": !_vm.isValid,
      "elevation": 0,
      "color": "success"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }